<template>
  <div>sub</div>
</template>
<script>
export default {
  name: 'Sub',
}
</script>
